module.exports = __webpack_public_path__ + "static/media/bestprice.8028af7d.svg";